<template>
    <div class="container-fluid">
        <p class="fs-5 mb-0">{{ $t('message.taraCount') }}: <b>{{ basicTaraAction }}</b></p>
        <ValidationObserver v-slot="{handleSubmit}">
            <form id="fd" @submit.prevent="handleSubmit(onSubmit)">
                <label>
                    {{ $t('modal.form.basic_tara_count') }}
                    <input v-model="form.basic_tara_count" type="number" min="0">
                </label>
                <div class="d-flex justify-content-between">
                  <div style="width: 90%">
                    <label>
                      {{ $t('modal.form.new_contracts_bottles_quantity') }}
                      <input v-model="form.new_contracts_bottles_quantity" type="number" min="0">
                    </label>
                  </div>
                  <div style="width: 10%" class="d-flex align-items-center">
                    <b-button variant="success" @click="openContractModal = true">+</b-button>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <div class="w-100">
                        <label>
                            {{ $t('modal.form.additional_tara_caunt') }}
                            <input v-model="form.additional_tara_caunt" type="number" min="0" disabled>
                        </label>
                    </div>
                    <div>
                        <b-button variant="primary" size="sm" @click="handleClickPlus"><i class='bx bx-plus fs-4'></i></b-button>
                    </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <div class="w-100">
                        <label>
                            {{ $t('modal.form.get_tara_count') }}
                            <input v-model="form.get_tara_count" type="number" min="0" disabled>
                        </label>
                    </div>
                    <div>
                        <b-button variant="danger" size="sm" @click="handleClickMinus"><i class='bx bx-minus fs-4'></i></b-button>
                    </div>
                </div>
                <label>
                    {{ $t('modal.form.not_sold_tara_count') }}
                    <input v-model="form.not_sold_tara_count" type="number" min="0">
                </label>
                <label>
                    {{ $t('modal.form.set_driver_money') }}
                    <p class="title mb-0">{{ checkSumTotal }}</p>
                </label>
                <ValidationProvider :name="$t('modal.form.set_driver_monet_real')" rules="required" v-slot="{errors}">
                    <label>
                        {{ $t('modal.form.set_driver_monet_real') }}
                        <input v-model="form.set_driver_monet_real" type="number" min="0" @input="handleDriverMoney">
                        <span class="text-danger">{{ errors[0] }}</span>
                    </label>
                </ValidationProvider>
                <label>
                    {{ $t('modal.form.debt_driver_money') }}
                    <p class="title mb-0">{{ debtSumTotal }}</p>
                </label>
                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="warning" @click="onClose">{{ $t('modal.button.back') }}</b-button>
                    <b-button class="ms-3" variant="success" type="submit" :disabled="db" form="fd">{{ $t('modal.button.finish') }}</b-button>
                </div>
            </form>
        </ValidationObserver>
        <b-modal v-model="getTaraModal" no-close-on-backdrop no-close-on-esc hide-footer hide-header size="xl">
            <div class="container-fluid">
                <div class="row">
                    <div v-for="(item, index) in actions.items" :key="index" class="col-lg-4">
                        <div class="border border-primary p-2 rounded mb-2">
                            <div>
                            <span class="me-2"><b class="text-primary">№</b> <h5 class="d-inline-block me-2">{{index + 1}}</h5></span>
                                <i class="bx bx-user fs-5 text-primary me-1"></i>
                                <span class="fs-5">{{item.client.full_name}}</span>
                            </div>
                            <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                <div>
                                    <i class='bx bx-target-lock fs-4 text-primary me-1'></i>
                                    <span class="fs-5">{{item.client.address}}</span>
                                </div>
                                <div>
                                    <i class='bx bx-mobile-alt fs-4 text-primary me-1'></i>
                                    <span class="fs-5" v-for="(num, idx) in item.client.numbers" :key="idx">{{num.mobile}}</span>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-6 text-center">
                                    <p class="mb-1 fs-6">
                                        <i class="mdi mdi-bottle-tonic-outline fs-4 text-primary"></i>
                                        {{ $t('table.old_bottles_count') }}
                                    </p>
                                    <span v-if="actions.plus">
                                        {{item.bottle_new_count - item.plus_bottle_count}}
                                    </span>
                                    <span v-if="actions.minus">
                                        {{item.bottle_new_count + item.minus_bottle_count}}
                                    </span>
                                </div>
                                <div class="col-sm-6 text-center">
                                    <p class="mb-1 fs-6">
                                        <i class="mdi mdi-bottle-tonic-outline fs-4 text-primary"></i>
                                        {{ $t('table.update_bottles_count') }}
                                    </p>
                                    {{item.bottle_new_count}}
                                </div>
                                <div class="col-12 text-center" v-if="actions.plus">
                                    <p class="mb-1 fs-6">
                                        <i class="bx bx-plus fs-4 text-success"></i>
                                        {{ $t('table.plus') }}
                                    </p>
                                    {{item.plus_bottle_count}}
                                </div>
                                <div class="col-12 text-center" v-if="actions.minus">
                                    <p class="mb-1 fs-6">
                                        <i class="bx bx-minus fs-4 text-danger"></i>
                                        {{ $t('table.minus') }}
                                    </p>
                                    {{item.minus_bottle_count}}
                                </div>
                            </div>
                            <hr>
                            <div>
                                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-1">
                                    <div>
                                        <i class="bx bx-user-voice fs-4 text-primary"></i>
                                        <span class="fs-5">{{ $t('dispatcher.labelName') }}</span>
                                    </div>
                                    <b class="fs-5">{{item.author.full_name}}</b>
                                </div>
                                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-1">
                                    <div>
                                        <i class="bx bx-user-voice fs-4 text-primary"></i>
                                        <span class="fs-5">{{ $t('data.ClientDriver') }}</span>
                                    </div>
                                    <b class="fs-5">{{item.client.driver.full_name}}</b>
                                </div>

                                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-1">
                                    <div>
                                        <i class="bx bxs-truck fs-4 text-primary"></i>
                                        <span class="fs-5">{{ $t('modal.form.driver.label') }}</span>
                                    </div>
                                    <b class="fs-5">{{item.driver.full_name}}</b>
                                </div>

                                <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-1">
                                    <div>
                                        <i class="bx bx-calendar   fs-4 text-primary"></i>
                                        <span class="fs-5">{{ $t('table.date') }}</span>
                                    </div>
                                    <b class="fs-5">{{item.created_at | createDate(item.created_at)}}</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-end gap-2">
                    <b-button variant="warning" @click="handleCloseGetTaraModal">{{ $t('modal.button.back') }}</b-button>
                </div>
            </div>
        </b-modal>
      <b-modal v-model="openContractModal" hide-footer hide-header size="lg">
          <b-table :items="finishOptions.contracts" :fields="contractFields">
            <template #cell(numbers)="{ item }">
              <span v-if="item.numbers.length">
                <div v-for="(number, index) in item.numbers" :key="index" class="w-100">
                  <span v-if="number.number">
                    {{ number.number  | VMask('###(##) ### ## ##') }}
                  </span>
                  <span v-if="number.mobile">
                    {{ number.mobile   | VMask('###(##) ### ## ##') }}
                  </span>
                </div>
              </span>
            </template>
          </b-table>
      </b-modal>
    </div>
</template>

<script>
import {finishManagerWaterRound} from '../../../../api/endpoints/managerWaterRound';
// import {getInfoByID} from '../../../../api/endpoints/products';
import  moment from 'moment'

export default {
    name: "ManagerWaterRound-FinishModal",
    props: {
        productsOptions: {
            type: Array,
            required: true
        },
        finishOptions: {
            type: Object,
            required: true
        },
        productPrice: {
            default: null
        },
        showMangerWaterDetails: {
            type: Object,
            required: true
        },
        showProductOptions: {
            type: Object,
            required: true
        },
    },
    filters: {
        createDate(date) {
            return moment(date).add(2, 'hours').format('DD-MM-YYYY hh:mm')
        }
    },
    data() {
        return {
            form: {
                id: this.finishOptions.id,
                basic_tara_count: null, // new
                new_contracts_bottles_quantity: null, //new
                additional_tara_caunt: null,
                get_tara_count: null,
                not_sold_tara_count: null,
                set_driver_money: null,
                set_driver_monet_real: null,
                debt_driver_money: null,
                productName: null,
            },
            sum: 0,
            taraCount: null,
            price: 0,
            //for other modal
            getTaraModal: false,
            data: null,
            actions: {
                plus: false,
                minus: false,
                plusCount: 0,
                minusCount: 0,
                items: null,
            },
            db: false,
          openContractModal: false,
          contractFields: [
            {
              key: "contract_number",
              label: "#"
            },
            {
              key: "full_name",
              label: this.$t("table.full_name.label"),
            },
            {
              key: "address",
              label: this.$t("table.address.label"),
            },
            {
              key: "numbers",
              label: this.$t("table.numbers.label"),
              class: "width_100",
            },
            {
              key: "bottles_count",
              label: this.$t("table.bottles_count")
            },
          ]
        }
    },
    computed: {
        basicTaraAction() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.sum = 0
            if (this.form.get_tara_count) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sum -= parseInt(this.form.get_tara_count);
            }
            if (this.form.additional_tara_caunt) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sum += parseInt(this.form.additional_tara_caunt);
            }
            if (this.form.not_sold_tara_count) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sum += parseInt(this.form.not_sold_tara_count);
            }
            if (this.form.basic_tara_count) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sum += parseInt(this.form.basic_tara_count);
            }
            if (this.form.new_contracts_bottles_quantity) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sum += parseInt(this.form.new_contracts_bottles_quantity);
            }

            return this.taraCount - this.sum;
        },
        checkSumTotal() {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.price = 0
            if (this.form.not_sold_tara_count) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.price += parseInt(this.form.not_sold_tara_count);
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.taraCount = this.showMangerWaterDetails.total_products_quantity
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            return (this.taraCount - this.price) * this.productPrice
        },
        debtSumTotal() {
            return this.checkSumTotal - this.form.set_driver_monet_real
        }
    },
    mounted() {
        this.checkSumModal();
        if (this.finishOptions.contracts.length) {
          let sum = 0;
          this.finishOptions.contracts.forEach(item => {
            sum += item.bottles_count;
          })
          this.form.new_contracts_bottles_quantity = sum;
        }
    },
    methods: {
        onClose() {
            this.$emit('onClose')
        },
        onSubmit() {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)

            let data = {
                id: this.form.id,
                products: [
                    {
                        product_id: this.showProductOptions.id,
                        quantity: this.taraCount
                    }
                ],
                empty_tara: this.form.basic_tara_count,
                new_contracts_bottles_quantity: this.form.new_contracts_bottles_quantity,
                extra_tara_count: this.form.additional_tara_caunt,
                returned_client_products: this.form.get_tara_count,
                returned_products_count: this.form.not_sold_tara_count,
                money_paid_by_driver: this.form.set_driver_monet_real,
                driver_debt: this.debtSumTotal,
            }
            for (const key in data) {
                if (data[key] === null) {
                    delete data[key]
                }
            }
            finishManagerWaterRound(data).then(() => {
                this.onClose()
            })
        },
        handleCloseGetTaraModal() {
            this.getTaraModal = false;
            this.actions.items = null;
            this.actions.plus = false;
            this.actions.minus = false;
        },
        handleClickPlus() {
            this.getTaraModal = true;
            this.actions.plus = true;
            this.actions.minus = false;
            this.actions.items = this.finishOptions.update_bottle_count.filter(el => el.minus_bottle_count == 0)
        },
        handleClickMinus() {
            this.getTaraModal = true;
            this.actions.plus = false;
            this.actions.minus = true;
            this.actions.items = this.finishOptions.update_bottle_count.filter(el => el.plus_bottle_count == 0);
        },
        checkSumModal() {
            let plusItem = this.finishOptions.update_bottle_count.map(val => val.plus_bottle_count)?.reduce((a, b) => a+b,0);
            let minusItem = this.finishOptions.update_bottle_count.map(val => val.minus_bottle_count)?.reduce((a, b) => a+b,0);
            this.form.additional_tara_caunt = plusItem;
            this.form.get_tara_count = minusItem;
            this.form.not_sold_tara_count = this.finishOptions.total_products_quantity - this.finishOptions.orders.map(item => item.count).reduce((a, b) => a+b, 0)
        },
      handleDriverMoney() {
        if (Number(this.form.set_driver_monet_real) > this.checkSumTotal) {
          this.form.set_driver_monet_real = this.checkSumTotal
        }
      }
    },

}
</script>
